import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a98e0b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "auth__main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "auth__logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "auth__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_sad_button = _resolveComponent("sad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.t('Auth.title')), 1),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loading, {
            key: 0,
            "data-test": "loading"
          }))
        : (_openBlock(), _createBlock(_component_sad_button, {
            key: 1,
            "data-test": "button",
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('Auth.signInWithAuth0')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
    ])
  ]))
}